var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1030_17018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7507 1.6665C7.62119 1.6666 6.50809 1.93681 5.50425 2.45458C4.50041 2.97236 3.63494 3.72268 2.98006 4.64297C2.32518 5.56325 1.89987 6.62679 1.73962 7.74487C1.57937 8.86295 1.68882 10.0031 2.05885 11.0703C2.42887 12.1375 3.04874 13.1007 3.86673 13.8796C4.68472 14.6585 5.67712 15.2305 6.76113 15.5478C7.84514 15.8652 8.98932 15.9187 10.0982 15.7039C11.2071 15.4892 12.2486 15.0123 13.1357 14.3132L16.179 17.3565C16.3362 17.5083 16.5467 17.5923 16.7652 17.5904C16.9837 17.5885 17.1927 17.5009 17.3472 17.3464C17.5017 17.1918 17.5894 16.9828 17.5913 16.7643C17.5932 16.5458 17.5092 16.3353 17.3574 16.1782L14.314 13.1348C15.1374 12.0904 15.65 10.8352 15.7933 9.51294C15.9366 8.19071 15.7047 6.85485 15.1242 5.65825C14.5437 4.46164 13.6381 3.45263 12.511 2.7467C11.3838 2.04076 10.0807 1.66641 8.7507 1.6665ZM3.33403 8.74984C3.33403 7.31325 3.90472 5.9355 4.92054 4.91968C5.93636 3.90385 7.31411 3.33317 8.7507 3.33317C10.1873 3.33317 11.565 3.90385 12.5809 4.91968C13.5967 5.9355 14.1674 7.31325 14.1674 8.74984C14.1674 10.1864 13.5967 11.5642 12.5809 12.58C11.565 13.5958 10.1873 14.1665 8.7507 14.1665C7.31411 14.1665 5.93636 13.5958 4.92054 12.58C3.90472 11.5642 3.33403 10.1864 3.33403 8.74984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1030_17018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteIcon);
export default __webpack_public_path__ + "static/media/searchWhiteIcon.d138ba94daabd510f1f3da34270c00af.svg";
export { ForwardRef as ReactComponent };